import "../../assets/css/auth.css";

import { Input, Spin, notification } from "antd";
import GenericModal from "../../components/modals/GenericModal";
import { LoadingOutlined } from "@ant-design/icons";

import { useState, useEffect } from "react";
import { Controller, useForm } from "react-hook-form";
import { Link, useNavigate, useParams } from "react-router-dom";
import { useDispatch } from "react-redux";
import { setUserData, setToken, profileData } from "../../slices/profileSlice";
import NaijaStates from "naija-state-local-government";
import * as yup from "yup";
import { yupResolver } from "@hookform/resolvers/yup";
import { ReactComponent as ArrowLeftIcon } from "../../assets/images/icons/arrow-left-circle.svg";
import PhoneInput from "react-phone-input-2";
import "react-phone-input-2/lib/style.css";

import AppRoutes from "../../common/routes";
import { _sign_user_up } from "../../common/axios_services";
import { signIn } from "../../common/axios_services";
import GoogleAuthButton from "../../components/GoogleAuthButton";

const SignUpPage = () => {
  const dispatch = useDispatch();
  let url = new URLSearchParams(window.location.search);
  let navigate = useNavigate();
  const antIcon = (
    <LoadingOutlined style={{ fontSize: 24, color: "#fff" }} spin />
  );

  let param = useParams();

  const [errorMessage, setErrorMessage] = useState("");
  const [appLoading, setAppLoading] = useState(false);
  const [fetchingData, setFetchingData] = useState(false);
  const [referralCode, setReferralCode] = useState("");
  const [isReferralLocked, setIsReferralLocked] = useState(false);
  const [openAuthResponseModal, setOpenAuthResponseModal] = useState(false);
  const [userLivingState, setUserLivingState] = useState("");
  const [allLgas, setAllLgas] = useState([]);

  const digitsOnly = (value) => /^\d+$/.test(value);

  const validator = yup.object().shape({
    password: yup.string().min(6).required("Password field is required"),
  });

  const openNotificationWithIcon = (type, message) => {
    notification[type]({
      message: "",
      description: message,
    });
  };



  const signupUser = async (e) => {
    setAppLoading(true);
    setErrorMessage("");

    let {
      first_name,
      last_name,
      email,
      phone_number,
      password,
      referral_code,
    } = e;

    if (referral_code && !(await validateReferralCode(referral_code))) {
      setAppLoading(false);
      setErrorMessage("Invalid referral code. Please enter a valid code.");
      return;
    }

    try {
      let cleaned = (phone_number || "").replace(/\D/g, "");
      if (cleaned.startsWith("2340")) {
        cleaned = "234" + cleaned.slice(4);
      } else if (cleaned.startsWith("0") && cleaned.length === 11) {
        cleaned = "234" + cleaned.slice(1);
      } else if (cleaned.length === 10 && /^[789]/.test(cleaned)) {
        cleaned = "234" + cleaned;
      }

      let phoneCode = "+234";
      let phoneNumber = cleaned;
      if (cleaned.startsWith("234")) {
        phoneCode = "+234";
        phoneNumber = cleaned.slice(3);
      }

      let saveUser = await _sign_user_up({
        firstName: first_name,
        lastName: last_name,
        email,
        password,
        referralCode: referral_code,
        phoneNumber: phoneNumber,
        phoneCode: phoneCode,
        role: "USER",
        app: "mobile",
      });
      if (saveUser?.data?.status === "error") {
        setAppLoading(false);
        return setErrorMessage(saveUser.data.message);
      }

      try {
        const loginResponse = await signIn({ email, password, app: "mobile" });
        dispatch(setUserData(null));
        dispatch(profileData(false));
        localStorage.setItem(
          "konnect_token",
          loginResponse?.data?.data?.accessToken
        );
        dispatch(setToken(loginResponse?.data?.data?.accessToken));
        localStorage.removeItem("signup_referral_code");
        navigate("/sms-verification", {
          state: { signupUserData: saveUser.data.data },
        });
      } catch (loginErr) {
        setErrorMessage(
          "Signup successful, but automatic login failed. Please try logging in manually."
        );
        navigate(AppRoutes.signin);
      }
      setAppLoading(false);
    } catch (err) {
      if (err?.response?.data?.message) {
        setErrorMessage(err?.response?.data?.message);
      } else if (err?.code === "ERR_NETWORK") {
        setErrorMessage(
          "An error occurred while signing user up. Please check network and try again"
        );
      } else {
        setErrorMessage(
          "An error occurred while signing user up. Please try again"
        );
      }
      setAppLoading(false);
      setOpenAuthResponseModal(true);
    }
  };

  const validateReferralCode = async (code) => {
    return !code || code?.length === 8;
  };

  const basicInfoValidator = yup.object().shape({
    first_name: yup.string().required("First name field is required"),
    last_name: yup.string().required("Last name field is required"),
    email: yup
      .string()
      .email("Email address is not valid")
      .required("Email address field is required"),
    password: yup.string().min(6).required("Password field is required"),
    phone_number: yup
      .string()
      .min(9, "Please enter a valid phone number")
      .required("Phone number field is required")
      .test("Digits only", "The field should have digits only", digitsOnly),
  });
  const {
    handleSubmit: handleBasicInfo,
    control: controlBasicInfo,
    formState: { errors: basicInfoError },
    setValue: setFormValue,
  } = useForm({
    resolver: yupResolver(basicInfoValidator),
  });

  const onChangeState = (value) => {
    if (value) {
      const allLGAsinAState = NaijaStates.lgas(`${value}`);
      setUserLivingState(value);
      setAllLgas(allLGAsinAState.lgas);
    }
  };

  useEffect(() => {
    const token = localStorage.getItem("konnect_token");
    if (token) {
      navigate(AppRoutes.home);
    }

    const urlRef = url.get("konnectrfc") || url.get("ref");
    const storedRef = localStorage.getItem("signup_referral_code");

    if (urlRef) {
      localStorage.setItem("signup_referral_code", urlRef);
      setReferralCode(urlRef);
      setFormValue("referral_code", urlRef);
      setIsReferralLocked(true);
    } else if (storedRef) {
      setReferralCode(storedRef);
      setFormValue("referral_code", storedRef);
      setIsReferralLocked(true);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [navigate]);

  return (
    <div className="signin-page">
      <div className="contain auth-content">
        <div className="mt_3 mb-24">
          <div>
            <div className="auth-sect-div">
              <h3 className="auth-sect-title">Create a free account</h3>
            </div>
          </div>
          {errorMessage.length ? (
            <p
              className="form-error"
              style={{ marginBottom: 30, display: "block" }}
            >
              {errorMessage}
            </p>
          ) : (
            ""
          )}
          <form onSubmit={handleBasicInfo(signupUser)}>
            <div className="grid-2">
              <div className="form_group">
                <label htmlFor="first_name">First name</label>
                <Controller
                  name="first_name"
                  control={controlBasicInfo}
                  render={({ field }) => (
                    <Input
                      name="first_name"
                      {...field}
                      id="first_name"
                      style={{ height: "5rem" }}
                    />
                  )}
                />
                {basicInfoError.first_name && (
                  <p className="form-error">
                    {basicInfoError.first_name.message}
                  </p>
                )}
              </div>
              <div className="form_group">
                <label htmlFor="last_name">Last name (Surname)</label>
                <Controller
                  name="last_name"
                  control={controlBasicInfo}
                  render={({ field }) => (
                    <Input
                      name="last_name"
                      {...field}
                      id="last_name"
                      style={{ height: "5rem" }}
                    />
                  )}
                />
                {basicInfoError.last_name && (
                  <p className="form-error">
                    {basicInfoError.last_name.message}
                  </p>
                )}
              </div>
            </div>
            <div className="grid-2">
              <div className="form_group">
                <label htmlFor="email">Email address</label>
                <Controller
                  name="email"
                  control={controlBasicInfo}
                  defaultValue=""
                  render={({ field }) => (
                    <Input
                      name="email"
                      {...field}
                      id="email"
                      style={{ height: "5rem" }}
                    />
                  )}
                />
                {basicInfoError.email && (
                  <p className="form-error">{basicInfoError.email.message}</p>
                )}
              </div>
              <div className="form_group">
                <label htmlFor="phone_number">Phone number</label>
                <Controller
                  name="phone_number"
                  control={controlBasicInfo}
                  defaultValue=""
                  render={({ field }) => (
                    <PhoneInput
                      country={"ng"}
                      {...field}
                      placeholder="0 000 000"
                      style={{ height: "5rem" }}
                      // value={this.state.phone}
                      // onChange={phone => this.setState({ phone })}
                    />
                    // <Input name="phone_number" type="tel" {...field} id="phone_number"
                    //     style={{ height: "5rem" }} />
                  )}
                />
                {basicInfoError.phoneNumber && (
                  <p className="form-error">
                    {basicInfoError.phoneNumber.message}
                  </p>
                )}
              </div>
            </div>
            <div className="form_group">
              <label htmlFor="password">Password</label>
              <Controller
                name="password"
                control={controlBasicInfo}
                defaultValue=""
                render={({ field }) => (
                  <Input.Password
                    name="password"
                    {...field}
                    id="password"
                    style={{ height: "5rem" }}
                  />
                )}
              />
              {basicInfoError.password && (
                <p className="form-error">{basicInfoError.password.message}</p>
              )}
            </div>
            <div className="form_group">
              <label htmlFor="referral_code">
                Referral Code (if referred by a friend)
              </label>
              <Controller
                name="referral_code"
                control={controlBasicInfo}
                defaultValue={referralCode}
                render={({ field }) => (
                  <Input
                    name="referral_code"
                    {...field}
                    id="referral_code"
                    readOnly={isReferralLocked}
                    disabled={isReferralLocked}
                    style={{
                      height: "5rem",
                      backgroundColor: isReferralLocked ? "#f5f5f5" : undefined,
                      color: isReferralLocked ? "#595959" : undefined,
                      cursor: isReferralLocked ? "not-allowed" : undefined,
                    }}
                  />
                )}
              />
            </div>
            <div className="welcome-buttons mt_15">
              <div className="welcome-buttons-content">
                <div>
                  {!appLoading ? (
                    <button className="btn-primary">
                      Create a free Account
                    </button>
                  ) : (
                    <button className="btn-primary">
                      <Spin indicator={antIcon} />
                    </button>
                  )}
                </div>
              </div>
            </div>
              <GoogleAuthButton isSignUp={true} />
          </form>
        </div>
      </div>
    </div>
  );
};

export default SignUpPage;
